export const UPDATE_FIELD = 'languages/UPDATE_FIELD'

export const FETCH_LANGUAGES_LIST_REQUEST = 'languages/FETCH_LANGUAGES_LIST_REQUEST'
export const FETCH_LANGUAGES_LIST_SUCCESS = 'languages/FETCH_LANGUAGES_LIST_SUCCESS'
export const FETCH_LANGUAGES_LIST_FAILURE = 'languages/FETCH_LANGUAGES_LIST_FAILURE'

